import fetchJSON from './fetchJSON';
import { API_VERSION } from './config';


const ALLOWED_METHODS = [
  'GET',
  'POST',
  'PUT',
  'PATCH',
  'HEAD',
  'OPTIONS',
  'DELETE',
];


export default async function callWebApi(method, url, body, authToken) {
  if (!ALLOWED_METHODS.includes(method)) {
    throw new TypeError(`callWebApi invalid argument: method=${method} is invalid`);
  }
  if (url.search(/\{\w+\}/) >= 0) {
    throw new TypeError(`callWebApi invalid argument: url=${url} contains a placeholder`);
  }
  const headers = {};
  if (['POST', 'PATCH', 'PUT'].includes(method)) {
    headers['Content-Type'] = 'application/json';
  }
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
    headers['X-Api-Version'] = API_VERSION;
  }
  return fetchJSON(url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
}



// WEBPACK FOOTER //
// ./src/callWebApi.js